import PropTypes from 'prop-types';

export default PropTypes.shape({
  pages: PropTypes.number,
  size: PropTypes.number,
  total: PropTypes.number,
});
